import React, { Component } from 'react';
import { AppNotification } from '../../atoms';
import { SW } from '../../../constants';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

export const TYPES = {
	COOKIE: 'cookiePolicy',
	PWA: 'pwaUpdate',
};

/**
 * The app notification for the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class AppNotificationView extends Component {

	state = {
		activeNotifications: {
			[TYPES.COOKIE]: !localStorage.getItem(TYPES.COOKIE),
			[TYPES.PWA]: false,
		},
	}

	componentDidMount () {
		window.addEventListener(SW.updateEvent, this.handleServiceWorkerUpdate);
	}

	componentWillUnmount () {
		window.removeEventListener(SW.updateEvent, this.handleServiceWorkerUpdate);
	}

	handleClick = (notificationType) => {
		switch (notificationType) {
			case TYPES.PWA:
				return () => window.location.reload();
			case TYPES.COOKIE:
				return () => {
					localStorage.setItem(TYPES.COOKIE, Date.now().toString());
					this.setState({
						activeNotifications: {
							...this.state.activeNotifications,
							[TYPES.COOKIE]: false,
						},
					});
				};
			default:
				break;
		}
	}

	handleServiceWorkerUpdate = () => {
		this.setState({
			activeNotifications: {
				...this.state.activeNotifications,
				[TYPES.PWA]: true,
			},
		});
	}

	renderNotification = (notificationType, notifications) => (
		<AppNotification
			key={notificationType}
			className='AppNotificationView-notification'
			buttonLabel={notifications[notificationType].buttonLabel}
			onClick={this.handleClick(notificationType)}
		>
			{notifications[notificationType].content}
		</AppNotification>
	);

	render () {
		const notifications = this.props.content.notifications;
		const activeNotifications = Object.entries(this.state.activeNotifications)
			.filter(([, value]) => value)
			.map(([key]) => key);

		return (
			<div className='AppNotificationView'>
				{activeNotifications.map((notificationType) =>
					this.renderNotification(notificationType, notifications)
				)}
			</div>
		);
	}

}

export default withLanguageContext(AppNotificationView);



// WEBPACK FOOTER //
// ./src/components/views/AppNotificationView/AppNotificationView.js